module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed br-pill z-999 fab-pos"
  }, [_c('button', {
    staticClass: "bg-theme white h3 w3 br-pill flex items-center justify-center pointer tc b--none",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_vm._t("default", function() {
    return [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('line', {
      attrs: {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }), _vm._v(" "), _c('line', {
      attrs: {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    })])]
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a49b00e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a49b00e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fab.vue
// module id = 1500
// module chunks = 0